const COLLECTION_ORDER_DETAIL = 'COLLECTION_ORDER_DETAIL';
const COLLECTION_ORDER_DETAIL_SUCCESS = 'COLLECTION_ORDER_DETAIL_SUCCESS';
const COLLECTION_ORDER_DETAIL_FAILURE = 'COLLECTION_ORDER_DETAIL_FAILURE';
const CLEAR_COLLECTION_ORDER_DETAIL = 'CLEAR_COLLECTION_ORDER_DETAIL';

const CollectionOrderDetailSymbols = {
  COLLECTION_ORDER_DETAIL_SUCCESS,
  COLLECTION_ORDER_DETAIL_FAILURE,
  COLLECTION_ORDER_DETAIL,
  CLEAR_COLLECTION_ORDER_DETAIL
};

export default CollectionOrderDetailSymbols;
